import { render, staticRenderFns } from "./deleteDashboard.vue?vue&type=template&id=0cbae4e7&scoped=true"
import script from "./deleteDashboard.vue?vue&type=script&lang=js"
export * from "./deleteDashboard.vue?vue&type=script&lang=js"
import style0 from "./deleteDashboard.vue?vue&type=style&index=0&id=0cbae4e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbae4e7",
  null
  
)

export default component.exports